import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class RotinaService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/rotina`;

  buscarRotinaSelect(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/select`);
  }

  buscarRotinaSelectPorPerfil(perfilId: number): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/select/${perfilId}`);
  }
}
